import React, { useEffect, useState } from "react";
import styles from '../Styles/fullpost.css';

function FullPost() {
    const title = localStorage.getItem("lpostTitle");
    const text = localStorage.getItem("lpostText");
    const imgLink = localStorage.getItem("lpostImageLink");
    const fileLink = localStorage.getItem("lpostFileLink");
    const fileName = localStorage.getItem("lFileName");
    const author = localStorage.getItem("lpostAuthor");

    return(
    <div className="FullPost">
        <div className="post">
            <div className="fpwrapper">
                <div className="titlewrap">
                    <h1 className="fprirle">{title}</h1>
                </div>
                <div className="grid-container">
                    <div className="grid-txt">
                        <div className="twrp">
                            <p className="postTxt">{text}</p>
                        </div>
                        <p className="author">{author}</p> 
                    </div>
                    <div className="grid-image">
                        {imgLink == null ? null : <img src={imgLink} className="postImg"/>}
                        {fileLink == null ? null : <a href={fileLink} className="postFile">{fileName}</a>}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default FullPost;
